import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState, useRef, useEffect } from 'react';
import getXcolumnJson from "./xcolumn/list";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import SearchReportArea from "./area/search_area";
import { useReactToPrint } from 'react-to-print';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import AddAttendPopup from "@/pages/comp/edu/attend/popup/add_attend";
import WriteTdAndStudyPopup from "./popup/write_td_and_study";
import ViewTodoDaySortPopup from "@/pages/comp/plan/calendar/area/popup/view_todo_day_sort";
import ViewStuLayerPopup from "@/pages/comp/basic/student/popup/view_layer";
import SendSMSPopup from "@/pages/comp/basic/sms/popup/send_sms";
import SMSSelectHPByUserPopup from "@/pages/comp/basic/sms/popup/sms_select_hp_by_user";
import FindStudyTitlePopup from "@/pages/comp/plan/study/study/popup/find_study_title";
import SendHomeWorkMsgPopup from "@/pages/comp/edu/daily_report/card_list/popup/send_home_work_msg";
import WriteTdDailyMemoPopup from "@/pages/comp/edu/daily_report/card_list/popup/write_td_memo";
import DailyReportTextListPopup from "@/pages/comp/edu/daily_report/card_list/popup/daily_report_text_list";
import FindMultyStudentPopup from "@/pages/comp/basic/student/popup/find_multy";
import SendPushPopup from "@/pages/comp/basic/push/popup/send";
import LoadingComponent from "@/pcomponents/common/content/loading";
import TodoInfoArrFunc from "@/pcomponents/common/content/todo/list/info_arr_func";
import DailyDataFunc from "@/pages/comp/edu/daily_report/card_list/func/daily_data_func";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import AttendStateFunc from "@/pcomponents/common/content/edu/attend/func/state_func";
import ExcelDownDailyReportArea from "./area/excel_down";
import ListTabArea from "./area/list_tab";
import SearchSubArea from "./area/search_sub";
import CardListArea from "./area/card_list";
import DailyListArea from "./area/daily_list";
import DataIo from "./area/io";

function DailyReportCardListPage() {
  const navigate = useNavigate();
  let user = useSelector((state: any) => state.user);
  const [list_tab, set_list_tab] = useState("day");//week,day
  const [tab_id, set_tab_id] = useState("lecture");
  const xColumnArr = getXcolumnJson();
  let now_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  let is_use_comp_study_textbook = user.comp_sort_detail == "growple" ? true : false;
  let default_list_opt:any = {
    ...xColumnArr.list_opt,
    s_grade: ["student"],
    s_stu_lecture_seq: (user.user_grade == "master"||user.user_grade == "super") ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ","),
    s_addon_lecture_time: "1",
    s_addon_stu_subject: "1",
    s_addon_link_user: "1",
    s_addon_daily_report_last: "1",
    s_addon_daily_report_last_addon_study_use: "",
    s_addon_daily_report_last_addon_book_use: "1",
    s_addon_study_det_by_daily_last: "",
    s_addon_textbook_det_by_daily_last: "1",
    s_addon_daily_report: "1",
    s_addon_daily_report_start_date: now_date_str,
    s_addon_daily_report_end_date: now_date_str,
    s_addon_daily_report_addon_study_use: "",
    s_addon_daily_report_addon_book_use: "",
    s_addon_daily_lecture_arr: "1",
    s_addon_todo: "1",
    s_addon_todo_start_date: now_date_str,
    s_addon_todo_end_date: now_date_str,
    s_addon_todo_s_todo_sort: "",
    s_addon_todo_elapse_time: "1",
    s_addon_todo_s_state: "",
    s_addon_todo_addon_par: "",
    s_addon_todo_addon_file: "1",
    // s_addon_home_work_file: "1",
    // s_addon_home_work_file_start_date: now_date_str,
    // s_addon_home_work_file_end_date: now_date_str,
    // s_addon_plan_study_file: "1",
    // s_addon_plan_study_file_start_date: now_date_str,
    // s_addon_plan_study_file_end_date: now_date_str,
    s_addon_attend: "1",
    s_addon_attend_start_date: now_date_str,
    s_addon_attend_end_date: now_date_str,
    s_attend_sort_detail: "",
    s_attend_start_date: now_date_str,
    s_attend_end_date: now_date_str,
    // s_addon_month_prescribe: "1",
    // s_addon_month_prescribe_start_date: now_date_str,
    // s_addon_month_prescribe_end_date: now_date_str,
    // s_addon_month_prescribe_writer_seq: "",
    // s_addon_month_prescribe_comment: "1",
    // s_addon_month_prescribe_counsel_todo: "1",
    s_addon_todo_dailyc: "1",
    s_addon_todo_dailyc_start_date: now_date_str,
    s_addon_todo_dailyc_end_date: now_date_str,
    s_addon_desk_use: "1",
    s_addon_desk_use_start_date: now_date_str,
    s_addon_desk_use_end_date: now_date_str,
    s_addon_daily_prescribe: "1",
    s_addon_daily_prescribe_start_date: now_date_str,
    s_addon_daily_prescribe_end_date: now_date_str,
    s_addon_daily_prescribe_last: "1",
    s_addon_tstu_todo: "1",
    s_addon_tstu_todo_start_date: now_date_str,
    s_addon_tstu_todo_end_date: now_date_str,
    // s_addon_tstu_todo_is_success:"empty",
    s_addon_tstu_todo_par_id: "daily_report",
  };
  if(is_use_comp_study_textbook){
    default_list_opt.s_addon_daily_report_last_addon_study_use = "1";
    default_list_opt.s_addon_study_det_by_daily_last="1";
  }
  const [listOpt, setListOpt] = useState({...default_list_opt});
  const listOptRef = useRef<any>(null);
  listOptRef.current = listOpt;
  listOptRef.current["s_select_date"] = listOpt.s_addon_daily_report_start_date;
  const [infoArr, setInfoArr] = useState<any>([]);
  const infoArrRef = useRef<any>([]);
  infoArrRef.current = infoArr;
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const group_data_arr_ref = useRef<any>([]);
  const [check_row_val_arr, set_check_row_val_arr] = useState<any>([]);//["stu_seq,lecture_seq,time_str"]
  const [is_able_save_daily_report, set_is_able_save_daily_report] = useState(true);
  const [sms_phone_check, set_sms_phone_check] = useState("student");//student,parent,both
  const [is_show_etc_group, set_is_show_etc_group] = useState(true);
  const [is_check_show_textarea, set_check_is_show_textarea] = useState(
    strFunc.get_storage("daily_report_is_check_show_textarea", "1") == "1" ? true : false
  );
  const [is_show_daily_prescribe, set_is_show_daily_prescribe] = useState(false);
  const [show_daily_prescribe_stu_subject_arr, set_show_daily_prescribe_stu_subject_arr] = useState([]);//["stu_seq,subject_name"]
  //strFunc.get_storage("daily_report_is_print_mode", "") == "1" ? true : false
  const [is_print_mode, set_is_print_mode] = useState(false);
  const [is_print_land, set_is_print_land] = useState(
    strFunc.get_storage("daily_report_is_print_land", "") == "1" ? true : false
  );
  const [show_group_time, set_group_time] = useState({
    sort: "",//"":전체,now::현재~,select:선택
    select_time_arr: [],//[13:00,14:00,..]
  });
  const able_time_arr_ref = useRef<any>([]);//[13:00,14:00,..]
  const ExcelDownDailyReportAreaRef = useRef<any>(null);
  const [refresh, set_refresh] = useState(false);
  const data_io_ref = useRef<any>(null);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "add_attend",//add_attend,write_td,send_home_work_msg
    attend_sort: "in",//in,out
    attend_sort_detail: "",
    user_info_arr: [],

    //todo
    select_stu_name: "",
    select_stu_seq: "",
    select_date: "",

    write_td_data: {
      daily_report: {},
      td_sort: "textbook",//textbook,subtextbook
    },

    write_page_data: {
      is_show: false,
      is_update: false,
      is_view_mode: true,
      is_view_basic: false,
      info_arr: [],
      select_idx: 0,
      default_write_info: {},
      tab_id: "monthly_prescribe",
      is_first_tab_scroll: true,
      counsel_s_select_date: "",
      month_prescribe_s_subject: "",
    },
    daily_report_arr: [],

    receive_arr: [],
    row_num: "",
    key_str: "",
    par_info: null,
    listOpt: {},

    receive_user_seq_arr: [],

    lecture_info: null,
    time_str: "",
    subject: "",
    except_stu_seq_arr: [],

    title: "출석",
    width: "800px",
    height: "100%",
    y: 0,
  });

  const time_table_wrap_ref = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => time_table_wrap_ref.current,
  });

  useEffect(() => {
    list({});
    expand_print_div_css();
  }, []);

  const expand_print_div_css = () => {
    if (time_table_wrap_ref.current) {
      // time_table_wrap_ref.current.style.transform="scale(1.15)";
      // time_table_wrap_ref.current.style.marginTop="100px";
    }
  };

  const list = (inOptObj: any) => {
    if (inOptObj.update_io_seq_arr == undefined) { inOptObj.update_io_seq_arr = []; }
    let tmp_listOpt: any = {
      ...listOpt,
      list_tab: list_tab,
      ...inOptObj
    };
    setListOpt(tmp_listOpt);
    let tmp_list_form_json = { ...tmp_listOpt };
    let tmp_select_date = tmp_listOpt.s_addon_daily_report_start_date;
    tmp_list_form_json["s_addon_todo_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_todo_end_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_home_work_file_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_home_work_file_end_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_plan_study_file_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_plan_study_file_end_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_attend_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_attend_end_date"] = tmp_select_date;
    tmp_list_form_json["s_attend_start_date"] = tmp_select_date;
    tmp_list_form_json["s_attend_end_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_desk_use_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_desk_use_end_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_todo_dailyc_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_todo_dailyc_end_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_daily_prescribe_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_daily_prescribe_end_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_tstu_todo_start_date"] = tmp_select_date;
    tmp_list_form_json["s_addon_tstu_todo_end_date"] = tmp_select_date;

    //하루전꺼부터 조회
    let tmp_start_date = tmp_list_form_json["s_addon_todo_start_date"];
    let tmp_start_date_json = DateFunc.get_date_json(new Date(tmp_start_date));
    let pre_date_change_num = -1;
    if (tmp_start_date_json.day == 1) {
      //일요일이면 3일뒤로이동(금요일부터 보이게한다.)
      pre_date_change_num = -3;
    }
    let pre_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', pre_date_change_num), "Y-m-d");
    tmp_list_form_json["s_addon_todo_start_date"] = pre_date_str;
    tmp_list_form_json["s_addon_home_work_file_start_date"] = pre_date_str;
    //데일리플랜 일주일 조회
    let week_date_change_num = -tmp_start_date_json.day;
    let week_date_change_end_num = 6 - tmp_start_date_json.day;
    let week_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', week_date_change_num), "Y-m-d");
    let week_date_end_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', week_date_change_end_num), "Y-m-d");
    tmp_list_form_json["s_addon_month_prescribe_start_date"] = week_date_str;
    tmp_list_form_json["s_addon_month_prescribe_end_date"] = week_date_end_str;
    if (tmp_listOpt.list_tab == "week") {
      tmp_list_form_json["s_addon_daily_report_start_date"] = week_date_str;
      tmp_list_form_json["s_addon_daily_report_end_date"] = week_date_end_str;
      tmp_list_form_json["s_addon_attend_start_date"] = week_date_str;
      tmp_list_form_json["s_addon_attend_end_date"] = week_date_end_str;
      tmp_list_form_json["s_attend_start_date"] = week_date_str;
      tmp_list_form_json["s_attend_end_date"] = week_date_end_str;
    } else if (tmp_listOpt.list_tab == "day") {
      tmp_list_form_json["s_addon_daily_report_start_date"] = tmp_select_date;
      tmp_list_form_json["s_addon_daily_report_end_date"] = tmp_select_date;
    }
    tmp_list_form_json["s_addon_tstu_todo_start_date"] = week_date_str;
    tmp_list_form_json["s_addon_tstu_todo_end_date"] = week_date_end_str;

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', tmp_list_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"] = TodoInfoArrFunc.get_info_arr_by_filter({
            info_arr: response.data["data"]["info_arr"],
            list_opt: tmp_list_form_json,
            base_date_str: tmp_select_date,
            pre_date_str: pre_date_str,
          });
          response.data["data"]["info_arr"] = DailyDataFunc.get_stu_list_of_setting_default_daily_info_arr({
            info_arr: response.data["data"]["info_arr"],
            select_date: tmp_start_date,
            tab_id: tab_id,
            user: user,
            is_filter_absent: true,
            writer_seq: user.user_seq,
            writer_name: user.user_name,
          });
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          //체크확인
          let tmp_check_row_val_arr: any = [];
          for (let check_i = 0; check_i < check_row_val_arr.length; check_i++) {
            let check_row_val = check_row_val_arr[check_i];
            let check_row_val_arr_split = check_row_val.split(",");
            let tmp_stu_seq = check_row_val_arr_split[0];
            let is_exist_stu = false;
            for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
              let stu_info = response.data["data"]["info_arr"][i];
              if (stu_info["a_seq"] == tmp_stu_seq) {
                is_exist_stu = true;
              }
            }
            if (is_exist_stu) {
              tmp_check_row_val_arr.push(check_row_val);
            }
          }
          if (tmp_check_row_val_arr.length != check_row_val_arr.length) {
            set_check_row_val_arr(tmp_check_row_val_arr);
          }

          if (inOptObj.update_io_seq_arr && inOptObj.update_io_seq_arr.length > 0) {
            update_io_of_user_arr({
              change_info_arr: response.data["data"]["info_arr"],
              update_seq_arr: inOptObj.update_io_seq_arr,
            });
          }

          set_refresh(!refresh);
        } else {

        }
      });
  };

  const on_check_all = (e: any) => {
    if (e.target.checked) {
      let tmp_pri_val_arr: any = [];
      for (let g_i = 0; g_i < group_data_arr_ref.current.length; g_i++) {
        let group_data = group_data_arr_ref.current[g_i];
        if (is_show_etc_group == false && group_data["title"] == "기타") {
          continue;
        }
        let tmp_lecture_seq = "";
        if (group_data["lecture_info"]) {
          tmp_lecture_seq = group_data["lecture_info"]["a_seq"];
        }

        for (let i = 0; i < group_data["info_arr"].length; i++) {
          let info = group_data["info_arr"][i];
          let tmp_card_row_pri_val = info["a_seq"] + "," + tmp_lecture_seq;
          if (list_tab == "day") {
            tmp_card_row_pri_val = info["a_seq"] + "," + tmp_lecture_seq + "," + group_data["time_str"] + "," + group_data["subject"];
          }

          tmp_pri_val_arr.push(tmp_card_row_pri_val);
        }
      }
      set_check_row_val_arr(tmp_pri_val_arr);
    } else {
      set_check_row_val_arr([]);
    }
  };

  const check_by_row_val = (row_val: string) => {
    if (strFunc.str_in_array(row_val, check_row_val_arr) == -1) {
      set_check_row_val_arr([
        ...check_row_val_arr,
        row_val
      ]);
    }
  };

  const get_select_stu_info_arr = (inData: any) => {
    let opt_obj = {
      is_except_absent: false,
      ...inData
    };
    let select_stu_info_arr: any = [];
    let tmp_stu_seq_arr: any = [];
    //학생키얻기
    for (let i = 0; i < check_row_val_arr.length; i++) {
      let row_val: any = check_row_val_arr[i];
      let tmp_stu_seq = row_val.split(",")[0];
      if (!strFunc.is_empty(tmp_stu_seq)) {
        if (strFunc.str_in_array(tmp_stu_seq, tmp_stu_seq_arr) == -1) {
          tmp_stu_seq_arr.push(tmp_stu_seq);
        }
      }
    }

    if (tmp_stu_seq_arr.length == 0) {
      return select_stu_info_arr;
    }
    //학생정보얻기
    for (let i = 0; i < infoArr.length; i++) {
      let info = infoArr[i];
      if (strFunc.str_in_array(info["a_seq"], tmp_stu_seq_arr) != -1) {
        select_stu_info_arr.push(info);
      }
    }

    if (opt_obj["is_except_absent"]) {
      //결석은 제외
      let new_select_stu_info_arr: any = [];
      for (let i = 0; i < select_stu_info_arr.length; i++) {
        if (select_stu_info_arr[i]["attend_state_str"] == "결석") {

        } else {
          new_select_stu_info_arr.push(select_stu_info_arr[i]);
        }
      }
      select_stu_info_arr = new_select_stu_info_arr;
    }

    return select_stu_info_arr;
  };

  const get_select_daily_report_arr = (inData: any) => {
    let opt_obj = {
      is_except_new: false,
      is_except_absent: false,
      is_except_no_homework: false,
      is_except_no_subject: true,
      select_date_str: listOpt.s_addon_daily_report_start_date,
      ...inData
    };
    let select_info_arr: any = [];
    let select_pri_val_arr: any = [];
    for (let i = 0; i < infoArr.length; i++) {
      let info: any = infoArr[i];
      if (opt_obj.is_except_absent) {
        if (info["attend_state_str"] == "결석") {
          continue;
        }
      }
      if (info.daily_report_arr) {
        for (let j = 0; j < info.daily_report_arr.length; j++) {
          let row_daily_info = info.daily_report_arr[j];
          if (opt_obj.is_except_no_homework) {
            //숙제없음 넘어가기
            if (row_daily_info["a_homework_state"] == "4") {
              continue;
            }
          }
          //과목없음 넘어가기
          if (opt_obj.is_except_no_subject) {
            if (strFunc.is_empty(row_daily_info["a_subject"])) {
              continue;
            }
          }
          row_daily_info["stu_info"] = {
            a_seq: info["a_seq"],
            a_user_name: info["a_user_name"],
            a_user_phone: info["a_user_phone"],
            a_stu_num: info["a_stu_num"],
            a_school_name: info["a_school_name"],
            a_stu_grade: info["a_stu_grade"],
            a_stu_state: info["a_stu_state"],
          };
          let row_lecture_seq = "";
          if (row_daily_info["a_lecture_seq"]) {
            row_lecture_seq = row_daily_info["a_lecture_seq"];
          }
          let row_pri_val = info["a_seq"] + "," + row_lecture_seq + "," + row_daily_info["a_lecture_time"] + "," + row_daily_info["a_subject"];

          if (strFunc.str_in_array(row_pri_val, check_row_val_arr) != -1) {
            if (row_daily_info["a_date"] == opt_obj["select_date_str"]
              && !strFunc.is_empty(row_daily_info["a_subject"])) {

              //중복제거
              if (strFunc.str_in_array(row_pri_val, select_pri_val_arr) == -1) {
                if (opt_obj.is_except_new) {
                  if (!strFunc.is_empty(row_daily_info["a_seq"])) {
                    select_info_arr.push(row_daily_info);
                    select_pri_val_arr.push(row_pri_val);
                  }
                } else {
                  select_info_arr.push(row_daily_info);
                  select_pri_val_arr.push(row_pri_val);
                }
              }

            }
          }
        }
      }
    }

    return select_info_arr;
  };

  const save_daily_report_by_stu_arr = (inData: any) => {
    let opt_obj = {
      report_data_arr: get_select_daily_report_arr({ is_except_new: false }),
      is_refresh_daily_study_title_arr: false,
      is_show_loading: true,
      ...inData
    };
    if (is_able_save_daily_report == false) {
      return false;
    }

    //필터링
    let new_report_data_arr: any = [];
    for (let i = 0; i < opt_obj.report_data_arr.length; i++) {
      let row_report_data = opt_obj.report_data_arr[i];
      let is_able_row = true;
      if (strFunc.is_empty(row_report_data["a_subject"])) {
        is_able_row = false;
      }
      if (is_able_row) {
        new_report_data_arr.push(row_report_data);
      }
    }
    opt_obj.report_data_arr = new_report_data_arr;

    //보고서 모으기
    let report_data_arr: any = opt_obj.report_data_arr;
    if (report_data_arr.length == 0) {
      //alert("저장 할 데이터가 없습니다.");
      return false;
    }
    if (opt_obj.is_show_loading) {
      set_loading_data({
        is_display: true,
        text: "저장 중입니다.",
      });
    }
    let w_report_form_json = {
      "data_arr": report_data_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/daily_report/write', w_report_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.is_show_loading) {
            set_loading_data({
              is_display: true,
              text: "저장 되었습니다.",
            });
          }

          let tmp_change_info_arr = DailyDataFunc.get_stu_info_arr_of_update_daily_info({
            info_arr: infoArr,
            update_daily_report_arr: response.data["data"],
          });
          setInfoArr(tmp_change_info_arr);
          if (opt_obj.is_refresh_daily_study_title_arr) {
            refresh_daily_study_title_arr_by_ajax({
              info_arr: tmp_change_info_arr,
              report_data_arr: report_data_arr,
            });
          }

          //change_user_arr
          let change_user_seq_arr: any = [];
          for (let i = 0; i < report_data_arr.length; i++) {
            change_user_seq_arr.push(report_data_arr[i]["a_stu_seq"]);
          }
          update_io_of_user_arr({
            change_info_arr: tmp_change_info_arr,
            update_seq_arr: change_user_seq_arr,
          });
        } else {
          alert(response.data["msg"]);
        }
        setTimeout(() => {
          set_loading_data({
            ...loading_data,
            is_display: false,
          });
        }, 600);
      });
  };

  const save_daily_prescribe_by_stu_arr = (inData: any) => {
    let opt_obj = {
      daily_prescribe_arr: [],
      is_show_loading: false,
      ...inData
    };
    //보고서 모으기
    let daily_prescribe_arr: any = opt_obj.daily_prescribe_arr;
    if (daily_prescribe_arr.length == 0) {
      alert("저장 할 데이터가 없습니다.");
      return false;
    }
    if (opt_obj.is_show_loading) {
      set_loading_data({
        is_display: true,
        text: "저장 중입니다.",
      });
    }
    let w_report_form_json = {
      "data_arr": daily_prescribe_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/prescribe/daily_prescribe/write', w_report_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.is_show_loading) {
            set_loading_data({
              is_display: true,
              text: "저장 되었습니다.",
            });
          }
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);

          let tmp_change_info_arr = DailyDataFunc.get_stu_info_arr_of_update_daily_prescribe({
            info_arr: infoArr,
            update_daily_prescribe_arr: response.data["data"],
          });
          setInfoArr(tmp_change_info_arr);

          //change_user_arr
          let change_user_seq_arr: any = [];
          for (let i = 0; i < daily_prescribe_arr.length; i++) {
            change_user_seq_arr.push(daily_prescribe_arr[i]["a_stu_seq"]);
          }
          update_io_of_user_arr({
            change_info_arr: tmp_change_info_arr,
            update_seq_arr: change_user_seq_arr,
          });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const delete_daily_prescribe_by_stu_arr = (inData: any) => {
    let opt_obj = {
      daily_prescribe_arr: [],
      is_show_loading: true,
      ...inData
    };
    let daily_prescribe_arr: any = opt_obj.daily_prescribe_arr;
    if (daily_prescribe_arr.length == 0) {
      alert("삭제 할 데이터가 없습니다.");
      return false;
    }
    for (let i = 0; i < daily_prescribe_arr.length; i++) {
      let row_data = daily_prescribe_arr[i];
      if (strFunc.is_empty(row_data["a_seq"])) {
        alert("삭제 할 수 없습니다.");
        return false;
      }
    }
    if (confirm("삭제 하시겠습니까?") == false) {
      return false;
    }
    if (opt_obj.is_show_loading) {
      set_loading_data({
        is_display: true,
        text: "삭제 중입니다.",
      });
    }
    let w_report_form_json = {
      "data_arr": daily_prescribe_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/prescribe/daily_prescribe/delete', w_report_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.is_show_loading) {
            set_loading_data({
              is_display: true,
              text: "삭제 되었습니다.",
            });
          }
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);

          let tmp_update_io_seq_arr: any = [];
          for (let i = 0; i < daily_prescribe_arr.length; i++) {
            let row_data = daily_prescribe_arr[i];
            if (strFunc.str_in_array(row_data["a_stu_seq"], tmp_update_io_seq_arr) == -1) {
              tmp_update_io_seq_arr.push(row_data["a_stu_seq"]);
            }
          }
          list({
            update_io_seq_arr: tmp_update_io_seq_arr
          });
        } else {
          alert(response.data["msg"]);
        }
      });
  }

  const update_io_of_user_arr = (inData: any) => {
    let opt_obj = {
      change_info_arr: [],
      is_only_include_seq: true,
      update_seq_arr: [],
      ...inData
    };

    let update_seq_arr = opt_obj.update_seq_arr;
    let change_info_arr: any = [];
    if (opt_obj.is_only_include_seq) {
      for (let i = 0; i < opt_obj.change_info_arr.length; i++) {
        let info = opt_obj.change_info_arr[i];
        if (strFunc.str_in_array(info["a_seq"], update_seq_arr) != -1) {
          change_info_arr.push(info);
        }
      }
    } else {
      change_info_arr = opt_obj.change_info_arr;
    }

    if (data_io_ref.current && change_info_arr) {
      data_io_ref.current.send({
        sort: "daily_report",
        "detail": "user_arr",
        "data": change_info_arr,
        "select_date": listOpt.s_addon_daily_report_start_date,
      });
    }
  };

  const refresh_daily_study_title_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      info_arr: infoArr,
      report_data_arr: [],
      ...inData,
    };

    let report_data_arr = opt_obj.report_data_arr;
    if (report_data_arr.length == 0) {
      return false;
    }
    let s_study_title_seq_arr = [];
    for (let i = 0; i < report_data_arr.length; i++) {
      if (!strFunc.is_empty(report_data_arr[i]["a_textbook_seq"])) {
        s_study_title_seq_arr.push(report_data_arr[i]["a_textbook_seq"]);
      }
      if (!strFunc.is_empty(report_data_arr[i]["a_subtextbook_seq"])) {
        s_study_title_seq_arr.push(report_data_arr[i]["a_subtextbook_seq"]);
      }
    }
    if (s_study_title_seq_arr.length == 0) {
      return false;
    }

    let tmp_form_json = {
      "s_seq": s_study_title_seq_arr,
      "s_addon_section": "1",
      "s_addon_study": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/study/study_title/list', tmp_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let tmp_change_info_arr: any = DailyDataFunc.get_stu_info_arr_of_update_study_title_arr({
            info_arr: opt_obj["info_arr"],
            study_title_arr: response.data["data"]["info_arr"],
          });
          setInfoArr(tmp_change_info_arr);
        } else {
          //alert(response.data["msg"]);
        }
      });
  };

  const delete_daily_report_by_stu_arr = () => {
    //보고서 모으기
    let report_data_arr: any = get_select_daily_report_arr({ is_except_new: true });

    if (report_data_arr.length == 0) {
      alert("삭제 할 데이터가 없습니다.");
      return false;
    }

    if (!confirm("삭제 하시겠습니까?")) {
      return false;
    }

    let w_report_form_json = {
      "data_arr": report_data_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/daily_report/delete', w_report_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "저장 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 1200);
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const onClickPrint = () => {
    if (time_table_wrap_ref.current) {
      time_table_wrap_ref.current.style.marginTop = "0px";
      time_table_wrap_ref.current.style.transform = "scale(1)";
      set_is_print_mode(true);
      setTimeout(() => {
        expand_print_div_css();
        set_is_print_mode(false);
      }, 3000);
      setTimeout(() => { handlePrint(); }, 500);
    }
  };

  const onClickExcelDown = () => {
    if (ExcelDownDailyReportAreaRef.current) {
      ExcelDownDailyReportAreaRef.current.go_excel_down({
        list_tab: list_tab,
        tab_id: tab_id,
        info_arr: infoArr,
        group_data_arr_ref: group_data_arr_ref,
        select_date: listOpt.s_addon_daily_report_start_date,
        is_print_mode: true,
        is_show_etc_group: is_show_etc_group,
        show_group_time: show_group_time,
        able_time_arr_ref: able_time_arr_ref,
        xColumnArr: xColumnArr,
      });
    }
  };

  const deleteAttend = (dataArr: any, confirm_msg: string) => {
    if (!confirm(confirm_msg)) {
      return false;
    }
    let del_form_data = {
      "data_arr": dataArr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/attend/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {

        }
      });
  };

  const open_send_push_popup = () => {
    let select_stu_info_arr = get_select_stu_info_arr({});
    if (select_stu_info_arr.length == 0) {
      alert("선택이 필요합니다.");
      return false;
    }
    let receive_user_seq_arr: any = [];
    for (let i = 0; i < select_stu_info_arr.length; i++) {
      receive_user_seq_arr.push(select_stu_info_arr[i].a_seq);
    }
    setPopupData({
      ...popupData,
      "receive_user_seq_arr": receive_user_seq_arr,
      "isOpen": true,
      "title": "푸시메세지 보내기",
      "sort": "send_push",
      width: "700px",
      height: "70%",
      has_header: true,
    });
  };

  const open_send_home_work_msg_popup = () => {
    let selected_arr = get_select_daily_report_arr({
      is_except_new: false,
      is_except_absent: true,
      is_except_no_homework: true,
    });

    if (selected_arr.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    //중복검사
    let tmp_daily_pri_val_arr: any = [];
    let tmp_select_arr: any = [];
    for (let i = 0; i < selected_arr.length; i++) {
      let tmp_row = selected_arr[i];
      let tmp_pri_val = tmp_row["a_stu_seq"] + "," + tmp_row["a_lecture_seq"];
      if (strFunc.str_in_array(tmp_pri_val, tmp_select_arr) == -1) {
        tmp_select_arr.push(tmp_pri_val);
        tmp_daily_pri_val_arr.push(tmp_row);
      }
    }
    selected_arr = tmp_daily_pri_val_arr;

    setPopupData({
      ...popupData,
      isOpen: true,
      has_header: true,
      sort: "send_home_work_msg",
      title: "숙제알림톡 전송",
      daily_report_arr: selected_arr,
    });
  };

  const open_sms_select_hp_by_user_popup = () => {
    let selected_row = get_select_stu_info_arr({});
    if (selected_row.length == 0) {
      alert("선택이 필요합니다.");
      return false;
    }

    let pop_title = "Message.";
    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": pop_title,
      "sort": "sms_select_hp_by_user",
      has_header: true,
      width: "300px",
      height: "200px",
    });
  };
  const callback_sms_select_hp_by_user_popup = (inData: any) => {
    let opt_obj = {
      select_opt: {
        "student": false,
        "par1": false,
        "par2": false,
      },
      ...inData
    };
    setTimeout(() => {
      openSendSMSPopup(opt_obj);
    }, 100);
  };
  const openSendSMSPopup = (inData: any) => {
    let opt_obj = {
      select_opt: {
        "student": false,
        "par1": true,
        "par2": false,
      },
      ...inData
    };
    let pop_title = "문자발송.";
    let selected_row = get_select_stu_info_arr({});
    if (selected_row.length == 0) {
      alert("선택이 필요합니다.");
      return false;
    }

    let receive_arr: any = [];
    for (let i = 0; i < selected_row.length; i++) {
      let row_data = selected_row[i];
      if (opt_obj.select_opt["student"]) {
        receive_arr.push({
          "user_seq": row_data.a_seq,
          "phone_num": strFunc.autoHypenPhone(row_data.a_user_phone),
          "user_name": row_data.a_user_name
        });
      }

      if (opt_obj.select_opt["par1"]) {
        if (row_data.link_user_arr && row_data.link_user_arr.length > 0 && row_data.link_user_arr[0]["par_info"]) {

          let par_info = row_data.link_user_arr[0]["par_info"];
          receive_arr.push({
            "user_seq": par_info.a_seq,
            "phone_num": strFunc.autoHypenPhone(par_info.a_user_phone),
            "user_name": par_info.a_user_name
          });
        }
      }
      if (opt_obj.select_opt["par2"]) {
        if (row_data.link_user_arr && row_data.link_user_arr.length >= 2 && row_data.link_user_arr[1]["par_info"]) {
          let par_info = row_data.link_user_arr[1]["par_info"];
          receive_arr.push({
            "user_seq": par_info.a_seq,
            "phone_num": strFunc.autoHypenPhone(par_info.a_user_phone),
            "user_name": par_info.a_user_name
          });
        }
      }
    }
    setPopupData({
      ...popupData,
      "receive_arr": receive_arr,
      "isOpen": true,
      "isUpdate": false,
      "title": pop_title,
      "sort": "send_sms",
      has_header: true,
      width: "800px",
      height: "85%",
    });
  };

  const openAttendPopup = (inData: any) => {
    let opt_obj = {
      selected_row: get_select_stu_info_arr({}),
      attend_sort: "in",
      attend_sort_detail: "",
      ...inData
    };
    let selected_row = opt_obj.selected_row;
    let attend_sort = opt_obj.attend_sort;
    let attend_sort_detail = opt_obj.attend_sort_detail;

    let pop_title = "등원";
    if (attend_sort == "out") {
      pop_title = "하원";
    }
    if (xColumnArr.select_arr.a_sort_detail) {
      for (let i = 0; i < xColumnArr.select_arr.a_sort_detail.length; i++) {
        let item = xColumnArr.select_arr.a_sort_detail[i];
        if (item.value == attend_sort_detail) {
          pop_title = item.text;
        }
      }
    }

    if (selected_row.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    let attend_date = listOpt.s_addon_daily_report_start_date;

    setPopupData({
      ...popupData,
      "isOpen": true,
      sort: "add_attend",
      "title": pop_title,
      attend_sort: attend_sort,
      attend_sort_detail: attend_sort_detail,
      select_date: attend_date,
      user_info_arr: selected_row,
      has_header: true,
    });
  };

  const open_write_td_data_popup = (inData: any) => {
    let opt_obj = {
      daily_report: {},
      td_sort: "textbook",//textbook,subtextbook
      ...inData
    };
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "write_td",
      title: "학습기록",
      write_td_data: {
        daily_report: opt_obj["daily_report"],
        td_sort: opt_obj["td_sort"]
      },
      width: "700px",
      has_header: true,
    });
  };
  const open_write_td_memo_popup = (inData: any) => {
    let opt_obj = {
      daily_report: {},
      td_sort: "a_memo",//textbook,subtextbook
      ...inData
    };
    if (is_able_save_daily_report == false) {
      return false;
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "write_td_memo",
      title: "메모수정",
      write_td_data: {
        daily_report: opt_obj["daily_report"],
        td_sort: opt_obj["td_sort"]
      },
      width: "700px",
      has_header: true,
    });
  };
  const callback_data_write_td_memo = (inData: any) => {
    let opt_obj = {
      change_daily_report: {},
      ...inData
    };
    let change_daily_report = opt_obj.change_daily_report;
    for (let info_i = 0; info_i < infoArr.length; info_i++) {
      let info = infoArr[info_i];
      if (info.daily_report_arr && info.daily_report_arr.length > 0) {
        for (let i = 0; i < info.daily_report_arr.length; i++) {
          let row_daily_info = info.daily_report_arr[i];
          if (!strFunc.is_empty(row_daily_info["a_seq"])) {
            if (row_daily_info["a_ymd"] == change_daily_report["a_ymd"]
              && row_daily_info["a_seq"] == change_daily_report["a_seq"]) {
              info.daily_report_arr[i] = change_daily_report;
            }
          } else {
            if (row_daily_info["a_lecture_seq"] == change_daily_report["a_lecture_seq"]
              && row_daily_info["a_stu_seq"] == change_daily_report["a_stu_seq"]
              && row_daily_info["a_date"] == change_daily_report["a_date"]
              && row_daily_info["a_lecture_time"] == change_daily_report["a_lecture_time"]
              && row_daily_info["a_subject"] == change_daily_report["a_subject"]) {
              info.daily_report_arr[i] = change_daily_report;
            }
          }
        }
      }
    }
    //체크하기
    let select_seq_str = change_daily_report["a_stu_seq"] + "," + change_daily_report["a_lecture_seq"] + "," + change_daily_report["a_lecture_time"];
    check_by_row_val(select_seq_str);
  };

  const openTodoDaySort = (inData: any) => {
    let opt_obj = {
      select_stu_name: "",
      select_stu_seq: "",
      select_date: listOpt.s_addon_daily_report_start_date,
      subject_name: "",
      ...inData
    };

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "todo_day_sort",
      title: "",
      width: "800px",
      has_header: true,
      ...opt_obj
    });
  };

  const open_stu_layer_popup = (inData: any) => {
    let opt_obj = {
      stu_info: null,
      lecture_info: null,
      is_scroll: false,
      ...inData
    };
    let stu_info = opt_obj.stu_info;
    if (strFunc.is_empty(stu_info)) {
      alert("학생정보가 없습니다.");
      return false;
    }
    let select_idx = 0;
    let stu_info_arr: any = [stu_info];

    let s_subject = "";
    if (!strFunc.is_empty(opt_obj["lecture_info"])) {
      s_subject = opt_obj["lecture_info"]["a_subject"];
    }

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "원생관리",
      "sort": "stu_view",
      write_page_data: {
        is_show: true,
        is_update: true,
        is_view_mode: true,
        is_view_basic: false,
        select_idx: select_idx,
        info_arr: stu_info_arr,
        default_write_info: {},
        tab_id: "monthly_prescribe",
        is_first_tab_scroll: opt_obj["is_scroll"],
        counsel_s_select_date: listOpt.s_addon_daily_report_start_date,
        month_prescribe_s_subject: s_subject,
      },
      width: "98%",
      height: "99%",
      y: 0,
      has_header: false,
    });
  };

  const open_find_study_title_popup = (inData: any) => {
    let opt_obj = {
      row_num: "",
      key_str: "",
      par_info: null,//daily_info
      ...inData
    };
    if (is_able_save_daily_report == false) {
      return false;
    }
    if (is_use_comp_study_textbook == false) {
      return false;
    }

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "find_study_title",
      title: "학습내용 찾기",
      row_num: opt_obj.row_num,
      key_str: opt_obj.key_str,
      par_info: opt_obj.par_info,
      listOpt: {
        s_addon_use_s_stu_seq: opt_obj.par_info["a_stu_seq"],
        s_subject_sort: opt_obj.par_info["a_subject"],
      },
      has_header: true,
      width: "700px",
      height: "80%",
      ...opt_obj
    });
  };

  const open_daily_report_text_popup = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    let tmp_select_stu_info_arr = get_select_stu_info_arr({
      is_except_absent: true,
    });

    if (tmp_select_stu_info_arr.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "daily_report_text",
      title: "데일리진도상담",
      stu_info_arr: tmp_select_stu_info_arr,
      has_header: true,
      width: "99%",
      height: "99%",
      ...opt_obj
    });
  };

  const callback_study_title = (inData: any) => {
    let opt_obj = {
      info_arr: [],
      row_num: "",
      key: "",
      par_info: null,
      ...inData
    };
    if (opt_obj["info_arr"].length == 0) {
      return false;
    }
    if (opt_obj.key == "a_textbook") {
      opt_obj["par_info"]["a_textbook"] = opt_obj["info_arr"][0]["a_title"];
      opt_obj["par_info"]["a_textbook_par_id"] = "";
      opt_obj["par_info"]["a_textbook_seq"] = opt_obj["info_arr"][0]["a_seq"];
      opt_obj["par_info"]["a_textbook_study"] = "";
      opt_obj["par_info"]["a_textbook_study_num"] = "";
      opt_obj["par_info"]["a_textbook_section_seq"] = "";
      opt_obj["par_info"]["a_textbook_study_det"] = "";
      opt_obj["par_info"]["a_textbook_study_det_num"] = "";
      opt_obj["par_info"]["a_textbook_detail_seq"] = "";
    } else if (opt_obj.key == "a_subtextbook") {
      opt_obj["par_info"]["a_subtextbook"] = opt_obj["info_arr"][0]["a_title"];
      opt_obj["par_info"]["a_subtextbook_par_id"] = "";
      opt_obj["par_info"]["a_subtextbook_seq"] = opt_obj["info_arr"][0]["a_seq"];
      opt_obj["par_info"]["a_subtextbook_study"] = "";
      opt_obj["par_info"]["a_subtextbook_study_num"] = "";
      opt_obj["par_info"]["a_subtextbook_section_seq"] = "";
      opt_obj["par_info"]["a_subtextbook_study_det"] = "";
      opt_obj["par_info"]["a_subtextbook_study_det_num"] = "";
      opt_obj["par_info"]["a_subtextbook_detail_seq"] = "";
    }
    save_daily_report_by_stu_arr({
      report_data_arr: [opt_obj["par_info"]],
      is_refresh_daily_study_title_arr: true,
    });
  };

  const callback_go_remove_select_title = (inData: any) => {
    let opt_obj = {
      info_arr: [],
      row_num: "",
      key: "",
      par_info: null,
      book_title: "",
      ...inData
    };
    if (!confirm("교재선택을 해제하시겠습니까?")) {
      return false;
    }
    if (opt_obj.key == "a_textbook") {
      opt_obj["par_info"]["a_textbook"] = opt_obj["book_title"];
      opt_obj["par_info"]["a_textbook_par_id"] = "";
      opt_obj["par_info"]["a_textbook_seq"] = "";
      opt_obj["par_info"]["a_textbook_study"] = "";
      opt_obj["par_info"]["a_textbook_study_det"] = "";
      opt_obj["par_info"]["a_textbook_study_num"] = "";
      opt_obj["par_info"]["a_textbook_section_seq"] = "";
      opt_obj["par_info"]["a_textbook_study_det_num"] = "";
      opt_obj["par_info"]["a_textbook_detail_seq"] = "";
    } else if (opt_obj.key == "a_subtextbook") {
      opt_obj["par_info"]["a_subtextbook"] = opt_obj["book_title"];
      opt_obj["par_info"]["a_subtextbook_par_id"] = "";
      opt_obj["par_info"]["a_subtextbook_seq"] = "";
      opt_obj["par_info"]["a_subtextbook_study"] = "";
      opt_obj["par_info"]["a_subtextbook_study_num"] = "";
      opt_obj["par_info"]["a_subtextbook_section_seq"] = "";
      opt_obj["par_info"]["a_subtextbook_study_det"] = "";
      opt_obj["par_info"]["a_subtextbook_study_det_num"] = "";
      opt_obj["par_info"]["a_subtextbook_detail_seq"] = "";
    }

    save_daily_report_by_stu_arr({
      report_data_arr: [opt_obj["par_info"]],
      is_refresh_daily_study_title_arr: true,
    });
  };

  const open_find_student_for_add_daily_report = (inData: any) => {
    let opt_obj = {
      lecture_info: null,
      time_str: "",
      subject: "",
      select_date: listOpt.s_addon_daily_report_start_date,
      except_stu_seq_arr: [],
      ...inData
    };

    setPopupData({
      ...popupData,
      isOpen: true,
      sort: "find_student",
      title: "학생찾기 (데일리플랜 추가)",
      select_date: opt_obj["select_date"],
      lecture_info: opt_obj["lecture_info"],
      time_str: opt_obj["time_str"],
      subject: opt_obj["subject"],
      except_stu_seq_arr: opt_obj["except_stu_seq_arr"],
      sort_detail: "add_daily_report",
      has_header: true,
      width: "800px",
      height: "99%",
      ...opt_obj
    });
  };

  const callback_find_student = (inData: any) => {
    let opt_obj = {
      info_arr: [],
      row_num: 0,
      key_str: "",
      ...inData
    };
    let tmp_stu_info_arr: any = opt_obj.info_arr;
    if (tmp_stu_info_arr.length == 0) {
      alert("학생이 없습니다.");
      return false;
    }

    //하루전꺼부터 조회
    let tmp_start_date = popupData.select_date;
    let tmp_start_date_json = DateFunc.get_date_json(new Date(tmp_start_date));
    let pre_date_change_num = -1;
    if (tmp_start_date_json.day == 1) {
      //일요일이면 3일뒤로이동(금요일부터 보이게한다.)
      pre_date_change_num = -3;
    }
    let pre_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', pre_date_change_num), "Y-m-d");

    if (popupData.sort_detail == "add_daily_report") {
      //데일리플랜 추가한다.
      let tmp_daily_report_arr: any = [];
      for (let i = 0; i < tmp_stu_info_arr.length; i++) {
        let tmp_stu_info = tmp_stu_info_arr[i];

        let row_last_daily_report_arr = [];
        if (tmp_stu_info.last_daily_report_arr) {
          row_last_daily_report_arr = tmp_stu_info.last_daily_report_arr;
        }
        let last_daily_info = DailyDataFunc.get_last_daily_info_by_lecture({
          stu_info: tmp_stu_info,
          lecture_info: popupData.lecture_info,
          last_daily_report_arr: row_last_daily_report_arr,
          subject: popupData.subject,
        });

        let daily_info = DailyDataFunc.get_daily_info_of_date({
          date_str: popupData.select_date,
          pre_date_str: pre_date_str,
          // is_now_date: true,
          last_daily_info: last_daily_info,
          lecture_time_str: popupData["time_str"],
          info: tmp_stu_info,
          lecture_info: popupData.lecture_info,
          user: user,
          subject: popupData.subject,
        });

        tmp_daily_report_arr.push(daily_info);

        if (tmp_daily_report_arr.length == 0) {
          alert("추가할 내용이 없습니다.");
          return false;
        }

        if (confirm("데일리플랜에 추가 하시겠습니까?")) {
          let tmp_form_json = {
            "data_arr": tmp_daily_report_arr,
          };
          my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/daily_report/write', tmp_form_json, get_axios_data())
            .then((response) => {
              if (response.data["result"] === "true") {
                alert("데일리플랜에 추가 되었습니다.");
                list({});
              } else {
                alert(response.data["msg"]);
              }
            });
        }
      }
    }
  };

  return (
    <CompLayout isConTitle={false} >
      <div className="con_wrap">
        <SearchArea
          sub_right_text={(<span>(총 <span className="main_text_color">{infoArr.length}</span>명)</span>)}
          listOpt={listOpt}
          setListOpt={setListOpt}
          xColumnArr={xColumnArr}
          list={list}
          search_line_right_text={(
            <div className="ml-2">
              <ListTabArea
                list_tab={list_tab}
                set_list_tab={(inData: any) => {
                  set_list_tab(inData);
                  strFunc.set_storage("daily_report_list_tab", inData);
                  list({ list_tab: inData });
                }}
              ></ListTabArea>
            </div>
          )}
        >
        </SearchArea>
        <SearchSubArea
          listOpt={listOpt}
          openAttendPopup={openAttendPopup}
          list={list}
          navigate={navigate}
          is_print_land={is_print_land}
          set_is_print_land={set_is_print_land}
          is_able_save_daily_report={is_able_save_daily_report}
          on_check_all={on_check_all}
          onClickPrint={onClickPrint}
          onClickExcelDown={onClickExcelDown}
          sms_phone_check={sms_phone_check}
          set_sms_phone_check={set_sms_phone_check}
          is_check_show_textarea={is_check_show_textarea}
          set_check_is_show_textarea={set_check_is_show_textarea}
          is_show_daily_prescribe={is_show_daily_prescribe}
          set_is_show_daily_prescribe={set_is_show_daily_prescribe}
          open_sms_select_hp_by_user_popup={open_sms_select_hp_by_user_popup}
          save_daily_report_by_stu_arr={save_daily_report_by_stu_arr}
          delete_daily_report_by_stu_arr={delete_daily_report_by_stu_arr}
          open_send_home_work_msg_popup={open_send_home_work_msg_popup}
          open_daily_report_text_popup={open_daily_report_text_popup}
          open_send_push_popup={open_send_push_popup}
        ></SearchSubArea>
        <div className="mt-2" ref={time_table_wrap_ref}>
          <style type="text/css" media="print">
            {is_print_land ? " @page { size: landscape; }@media print {html,body {width: 290mm;max-height:201mm; }} " : ""}
          </style>
          {list_tab == "week" &&
            <CardListArea
              tab_id={tab_id}
              info_arr={infoArr}
              set_info_arr={(inData: any) => {
                setInfoArr(inData);
                set_refresh(!refresh);
              }}
              group_data_arr_ref={group_data_arr_ref}
              select_date={listOpt.s_addon_daily_report_start_date}
              list={list}
              check_row_val_arr={check_row_val_arr}
              set_check_row_val_arr={(inData: any) => {
                set_check_row_val_arr([...inData]);
              }}
              is_print_mode={is_print_mode}
              is_able_save_daily_report={is_able_save_daily_report}
              is_show_etc_group={is_show_etc_group}
              show_group_time={show_group_time}
              set_group_time={set_group_time}
              able_time_arr_ref={able_time_arr_ref}
              xColumnArr={xColumnArr}
              openAttendPopup={openAttendPopup}
              deleteAttend={deleteAttend}
              open_write_td_data_popup={open_write_td_data_popup}
              openTodoDaySort={openTodoDaySort}
              open_stu_layer_popup={open_stu_layer_popup}
            ></CardListArea>
          }
          {list_tab == "day" &&
            <DailyListArea
              tab_id={tab_id}
              info_arr={infoArr}
              set_info_arr={(inData: any) => {
                setInfoArr(inData);
                set_refresh(!refresh);
              }}
              group_data_arr_ref={group_data_arr_ref}
              select_date={listOpt.s_addon_daily_report_start_date}
              list={list}
              check_row_val_arr={check_row_val_arr}
              set_check_row_val_arr={(inData: any) => {
                set_check_row_val_arr([...inData]);
              }}
              is_print_mode={is_print_mode}
              is_able_save_daily_report={is_able_save_daily_report}
              is_show_etc_group={is_show_etc_group}
              is_check_show_textarea={is_check_show_textarea}
              is_show_daily_prescribe={is_show_daily_prescribe}
              show_daily_prescribe_stu_subject_arr={show_daily_prescribe_stu_subject_arr}
              set_show_daily_prescribe_stu_subject_arr={set_show_daily_prescribe_stu_subject_arr}
              show_group_time={show_group_time}
              set_group_time={set_group_time}
              able_time_arr_ref={able_time_arr_ref}
              xColumnArr={xColumnArr}
              save_daily_report_by_stu_arr={save_daily_report_by_stu_arr}
              save_daily_prescribe_by_stu_arr={save_daily_prescribe_by_stu_arr}
              delete_daily_prescribe_by_stu_arr={delete_daily_prescribe_by_stu_arr}
              openAttendPopup={openAttendPopup}
              deleteAttend={deleteAttend}
              open_write_td_data_popup={open_write_td_data_popup}
              open_write_td_memo_popup={open_write_td_memo_popup}
              openTodoDaySort={openTodoDaySort}
              open_stu_layer_popup={open_stu_layer_popup}
              open_find_study_title_popup={open_find_study_title_popup}
              open_find_student_for_add_daily_report={open_find_student_for_add_daily_report}
            ></DailyListArea>
          }
        </div>
        <div className="mt-2">
          <Paging now_page={listOpt.now_page}
            num_per_page={listOpt.num_per_page}
            total_rec={countInfo.tot}
            onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
            is_view_num_per_page={true}
            onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
        </div>
      </div>
      <div className="mt-1">
        코어,솔루션 배경색:
        <span style={{ color: AttendStateFunc.attend_color_json.attend.background }}>■</span> 4주,
        <span style={{ color: AttendStateFunc.attend_color_json.late.background }}>■</span> 6주,
        <span style={{ color: AttendStateFunc.attend_color_json.absent.background }}>■</span> 8주
      </div>
      {/* <div>
        <label className="ml-1">
          <input type="checkbox" checked={is_show_etc_group ? true : false} value="1"
            onChange={(e: any) => {
              strFunc.set_storage("daily_report_is_show_etc_group", e.target.checked ? "1" : "");
              set_is_show_etc_group(e.target.checked);
            }} />
          기타
        </label>
      </div> */}
      <ExcelDownDailyReportArea
        ref={ExcelDownDailyReportAreaRef}
      ></ExcelDownDailyReportArea>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} title_bar_style={{ borderBottom: 0 }}
          content_div_style={{ padding: "10px 0px" }} y={popupData.y} has_header={popupData.has_header}  >
          {popupData.sort == "send_sms" &&
            <SendSMSPopup
              receive_arr={popupData.receive_arr}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
              callBackRefresh={list}
            ></SendSMSPopup>
          }
          {popupData.sort == "sms_select_hp_by_user" &&
            <SMSSelectHPByUserPopup
              callback_data={callback_sms_select_hp_by_user_popup}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SMSSelectHPByUserPopup>
          }
          {popupData.sort === "add_attend" &&
            <AddAttendPopup attend_sort={popupData.attend_sort}
              attend_sort_detail={popupData.attend_sort_detail}
              attend_date={popupData.select_date}
              userInfoArr={popupData.user_info_arr}
              callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></AddAttendPopup>
          }
          {popupData.sort === "write_td" &&
            <WriteTdAndStudyPopup
              list={list}
              daily_report={popupData.write_td_data.daily_report}
              td_sort={popupData.write_td_data.td_sort}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTdAndStudyPopup>
          }
          {popupData.sort === "write_td_memo" &&
            <WriteTdDailyMemoPopup
              daily_report={popupData.write_td_data.daily_report}
              td_sort={popupData.write_td_data.td_sort}
              list={() => { }}
              callback_data={callback_data_write_td_memo}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTdDailyMemoPopup>
          }
          {popupData.sort == "todo_day_sort" &&
            <ViewTodoDaySortPopup
              list_opt={{
                "s_stu_user_name": popupData.select_stu_name,
                "s_stu_user_seq": popupData.select_stu_seq,
                "s_start_date": popupData.select_date,
                "s_end_date": popupData.select_date,
                "s_subject": popupData.subject_name,
              }}
              list={list}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewTodoDaySortPopup>
          }
          {popupData.sort === "stu_view" &&
            <ViewStuLayerPopup
              write_page_data={popupData.write_page_data}
              callback={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewStuLayerPopup>
          }
          {popupData.sort === "find_study_title" &&
            <FindStudyTitlePopup
              row_num={popupData.row_num}
              key_str={popupData.key_str}
              par_info={popupData.par_info}
              listOpt={popupData.listOpt}
              is_remove_select_title_btn={true}
              go_remove_select_title={callback_go_remove_select_title}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
              callBackData={callback_study_title}
            ></FindStudyTitlePopup>
          }
          {popupData.sort === "send_home_work_msg" &&
            <SendHomeWorkMsgPopup
              daily_report_arr={popupData.daily_report_arr}
              list={list}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SendHomeWorkMsgPopup>
          }
          {popupData.sort === "daily_report_text" &&
            <DailyReportTextListPopup
              stu_info_arr={popupData.stu_info_arr}
              select_date={listOpt.s_addon_daily_report_start_date}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></DailyReportTextListPopup>
          }
          {popupData.sort === "find_student" &&
            <FindMultyStudentPopup
              listOpt={{
                s_except_user_seq: popupData.except_stu_seq_arr,
                s_addon_daily_report_last: "1",
                s_addon_daily_report_last_addon_study_use: "1",
                s_addon_study_det_by_daily_last: "1",
                s_addon_daily_report: "1",
                s_addon_daily_report_start_date: listOpt.s_addon_daily_report_start_date,
                s_addon_daily_report_end_date: listOpt.s_addon_daily_report_start_date,
                s_addon_daily_report_addon_study_use: "",
              }}
              callBackData={callback_find_student}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></FindMultyStudentPopup>
          }
          {popupData.sort === "send_push" &&
            <SendPushPopup
              receive_user_seq_arr={popupData.receive_user_seq_arr}
              callback={() => { }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></SendPushPopup>
          }
        </LayerPopup>
      }
      {loading_data.is_display &&
        <LoadingComponent text={loading_data.text}></LoadingComponent>
      }
      <DataIo
        data_io_ref={data_io_ref}
        infoArrRef={infoArrRef}
        setInfoArr={setInfoArr}
        listOptRef={listOptRef}
      ></DataIo>
    </CompLayout>
  );
};
export default DailyReportCardListPage;